/**
 * 获取指定车型详细参数
 * http://mockjs.com/
 */
import Mock from 'mockjs'
import cache from '../../common/cache'
let mock = cache.getSessionData('mock')
// mock 开关
let mockSwitch = mock ? '' : '_'

// 获取车辆基本信息
// 接口地址  /api/v1/auctions/{auction_id}/brief
Mock.mock(/\/auctions\/\d+\/bids/, 'get' + mockSwitch, {
  'code': 0,
  'message': 'ok',
  'data': {
    'auction': {
      'id': 1, // 拍卖id,用于选择撮合车商
      'bidders_count': 1,
      'bids_count': 1,
      'maximum_price': 13000000,
      'minimum_price': 12300000,
      'reserve_price': 15000000,
      'quote_increment': 55500,
      'session': '2018年01月08日 20:02场',
      'status_name': '流拍'
    },
    'bids|10': [{
      'bidden_at': '2018-01-08 20:02:50',
      'bidder': {
        'city': '深圳市',
        'garage_name': '南山',
        'garage_type': 1,
        'garage_type_name': '二手车经销商',
        'id': 37,
        'mobile_number': '18665368712',
        'name': '涂蓉',
        'province': '广东省',
        'status': 1,
        'status_code': 'active'
      },
      'id': 47,
      'price': 13000000,
      'selected': false
    }],
    'matchable': true, // 可否提交撮合
    'match_status': 0, // 详见约定
    'match_status_code': 'unmatching',
    'match_submit_before': '2018-5-1 12:12:12'
  }
})
